import React from 'react';
import {Card, CardHeader, CardBody, CardFooter, Link, Button} from "@nextui-org/react";

const Result = ({ passValues, getRefresh }) => {
    const interes = 7.40;
    let final = 0;
    final = passValues.monto * (Math.pow(1+interes/100, passValues.cuotas)*interes/100)/(Math.pow(1+interes/100, passValues.cuotas)-1);
    const resultado = (""+final).split('.')[1].length > 0 ?
        parseFloat(final.toFixed(2)).toLocaleString() :
        parseFloat(final.toFixed(2)).toLocaleString() + '0';

    const handleRefresh = (e) => {
        e.preventDefault();
        getRefresh(false);
    };

    const montoSolicitado = parseInt(passValues.monto);

    return (
        <Card className="results-wrapper">
            <CardHeader className="flex gap-3">
                <div className="flex flex-col">
                    <p className="text-medium">Plan seleccionado: <b>{passValues.plan}</b></p>
                    <p className="text-medium">Total solicitado: <b>${montoSolicitado.toLocaleString()}</b></p>
                    <p className="text-medium">Cantidad de cuotas: <b>{passValues.cuotas}</b></p>
                </div>
            </CardHeader>
            <CardBody>
                <p className="text-medium">Monto de cada cuota:</p>
                <h1 className="resultNumber">${resultado}</h1>
              {/*<p className="text-small infoText">*/}
              {/*      En caso de que la Ayuda Económica sea solicitada*/}
              {/*      por Socios sin planes de salud,*/}
              {/*      se cobrará el 5 % en concepto de Gastos Administrativos.*/}
              {/*  </p>*/}
            </CardBody>
            <CardFooter className={"buttonsGroup"}>
                <Link
                    isExternal
                    href="https://wa.me/+5493425141873"
                    className="btnConsult"
                >
                    Consultá ahora
                </Link>
                <Button
                    className="btnSubmitLinear"
                    onClick={handleRefresh}
                >
                    Volver a simular
                </Button>
            </CardFooter>
        </Card>
    )
}

export default Result;


